import { render, staticRenderFns } from "./NodePopupDocument.vue?vue&type=template&id=fb2362ec"
import script from "./NodePopupDocument.vue?vue&type=script&lang=js"
export * from "./NodePopupDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports